import styled from 'styled-components';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { themeColor, themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';

export const StyledSection = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${themeSpace(9)} ${themeSpace(5)};
`;

export const StyledHeading = styled(Text)`
  margin-bottom: ${themeSpace(4)};
`;

export const AppRatingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${themeSpace(3)};
  ${themeVariant('featureCopy17')};
  color: ${themeColor('mono1')};

  .registry-rating-stars {
    color: #f5a623;
    letter-spacing: 2px;
  }

  ${themeMediaQuery('below_sm')} {
    flex-direction: column;
    gap: ${themeSpace(2)};
  }
`;
